import {
  IFboBankAccountImportPayload,
  IFboBankAccountCreatePayload,
  IFboBankAccountUpdatePayload,
} from '@common/interfaces/fboBankAccount'
import Base from './base'

export default class FboBankAccount extends Base {
  list(params: object = {}) {
    return this.apiClient.get('fbo-bank-accounts', params)
  }

  summary() {
    return this.apiClient.get('fbo-bank-accounts/summary')
  }

  create(data: IFboBankAccountCreatePayload) {
    return this.apiClient.post('fbo-bank-accounts', data)
  }

  bulkImport(data: IFboBankAccountImportPayload) {
    return this.apiClient.post('fbo-bank-accounts/import', data)
  }

  update(id: string, data: IFboBankAccountUpdatePayload) {
    return this.apiClient.put(`fbo-bank-accounts/${id}`, data)
  }
}
